var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26935 9.41872C8.69106 8.96175 9.37488 8.96165 9.7967 9.4185L12.8131 12.6854L15.8295 9.4185C16.2514 8.96165 16.9352 8.96175 17.3569 9.41872C17.7786 9.87569 17.7785 10.6165 17.3567 11.0734L13.5767 15.1673C13.155 15.624 12.4713 15.624 12.0495 15.1673L8.26955 11.0734C7.84773 10.6165 7.84764 9.87569 8.26935 9.41872Z",
    fill: "#3F4159"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8134 2.25C13.4099 2.25 13.8934 2.77383 13.8934 3.42V14.3371C13.8934 14.9833 13.4099 15.5071 12.8134 15.5071C12.2169 15.5071 11.7334 14.9833 11.7334 14.3371V3.42C11.7334 2.77383 12.2169 2.25 12.8134 2.25Z",
    fill: "#3F4159"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89348 13.17C5.48994 13.17 5.97348 13.6939 5.97348 14.34V19.41H19.6535V14.34C19.6535 13.6939 20.137 13.17 20.7335 13.17C21.3299 13.17 21.8135 13.6939 21.8135 14.34V19.8C21.8135 20.3172 21.6238 20.8132 21.2863 21.1789C20.9487 21.5446 20.4909 21.75 20.0135 21.75H5.61348C5.13609 21.75 4.67825 21.5446 4.34068 21.1789C4.00312 20.8132 3.81348 20.3172 3.81348 19.8V14.34C3.81348 13.6939 4.29701 13.17 4.89348 13.17Z",
    fill: "#3F4159"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownload);
export default __webpack_public_path__ + "static/media/ico-download.fd83ea72.svg";
export { ForwardRef as ReactComponent };